import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { localIntervalMap } from './time-interval';
import { utcIntervalMap } from './utc-interval';
import { bisect } from './bisect';
import { tickStep } from './ticks';
function chooseTickIntervals(utc) {
  var intervalMap = utc ? utcIntervalMap : localIntervalMap;
  var year = intervalMap.year,
    month = intervalMap.month,
    week = intervalMap.week,
    day = intervalMap.day,
    hour = intervalMap.hour,
    minute = intervalMap.minute,
    second = intervalMap.second,
    millisecond = intervalMap.millisecond;
  var tickIntervals = [[second, 1], [second, 5], [second, 15], [second, 30], [minute, 1], [minute, 5], [minute, 15], [minute, 30], [hour, 1], [hour, 3], [hour, 6], [hour, 12], [day, 1], [day, 2], [week, 1], [month, 1], [month, 3], [year, 1]];
  return {
    tickIntervals: tickIntervals,
    year: year,
    millisecond: millisecond
  };
}
export function findTickInterval(start, stop, count, interval, utc) {
  var lo = +start;
  var hi = +stop;
  var _chooseTickIntervals = chooseTickIntervals(utc),
    tickIntervals = _chooseTickIntervals.tickIntervals,
    year = _chooseTickIntervals.year,
    millisecond = _chooseTickIntervals.millisecond;
  var getter = function getter(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      interval = _ref2[0],
      count = _ref2[1];
    return interval.duration * count;
  };
  var targetCount = interval ? (hi - lo) / interval : count || 5;
  var targetInterval = interval || (hi - lo) / targetCount;
  var len = tickIntervals.length;
  var i = bisect(tickIntervals, targetInterval, 0, len, getter);
  var matchInterval;
  if (i === len) {
    var step = tickStep(lo / year.duration, hi / year.duration, targetCount);
    matchInterval = [year, step];
  } else if (i) {
    var closeToLow = targetInterval / getter(tickIntervals[i - 1]) < getter(tickIntervals[i]) / targetInterval;
    var _ref3 = closeToLow ? tickIntervals[i - 1] : tickIntervals[i],
      _ref4 = _slicedToArray(_ref3, 2),
      timeInterval = _ref4[0],
      targetStep = _ref4[1];
    var _step = interval ? Math.ceil(interval / timeInterval.duration) : targetStep;
    matchInterval = [timeInterval, _step];
  } else {
    var _step2 = Math.max(tickStep(lo, hi, targetCount), 1);
    matchInterval = [millisecond, _step2];
  }
  return matchInterval;
}